import Bowser from 'bowser';

export const useDeviceBrowser = () => {
  const browser = Bowser.getParser(window.navigator.userAgent);

  return {
    isMobile: browser.getPlatformType() === 'mobile' || browser.getPlatformType() === 'tablet',
    system: browser.getOS(),
  };
};
